<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" label-width="120px" ref="form" :disabled="disabled" :model="formParameter"
				:inline="true" :rules="rules">
				<el-row>
					<el-col :span="12">
						<el-form-item label="计划跟进时间" prop="gnneedtm">
							<el-date-picker v-model="formParameter.gnneedtm" type="date" placeholder="选择日期">
							</el-date-picker></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="跟进时间" prop="gntm">
							<el-date-picker v-model="formParameter.gntm" type="date" placeholder="选择日期">
							</el-date-picker></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">

						<el-form-item label="被跟进人" prop="stuid"><el-input v-model="formParameter.stuid"
								autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="跟进人" prop="username"><el-input v-model="formParameter.username"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="金额" prop="cost"><el-input v-model="formParameter.cost"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="跟进类型" prop="type"><el-input v-model="formParameter.type"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="跟进内容" prop="content"><el-input v-model="formParameter.content"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="推送的消息" prop="message"><el-input v-model="formParameter.message"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="消息接受时间" prop="msgtm">
							<el-date-picker v-model="formParameter.msgtm" type="date" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="跟进结果" prop="result"><el-input v-model="formParameter.result"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="跟进记录" prop="records"><el-input v-model="formParameter.records"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/xueli/xlsturecord.js';
export default {
	name: 'edit',
	components: {
		popup
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			rules: {}
		};
	},
	methods: {
		//打开弹框
		open(parameter, title, disabled, size) {

			this.formParameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, "75%");

		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		}

	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
